import request from '@/utils/request'
import { Model } from '@/api/base'
import { getAccountId } from '@/utils/init/pubs'

// 用户
const model = new Model()
const order = model.usePath('dev', 'v1/order')
const wechat = model.usePath('dev', 'wx/oauth')
const wechat2 = model.usePath('dev', 'v2/wx/oauth')

export default {
  // 获取签名
  getJssdkConfig(data) {
    return request({
      url: order('getWxJsApiSignature'),
      method: 'post',
      data
    })
  },

  // 认证
  authorize(redirectUrl, state) {
    const accountId = getAccountId()
    return request({
      url: wechat('getOauth' + `?accountId=${accountId}&redirectUrl=${redirectUrl}&state=${state}`),
      method: 'post'
    })
  },

  // 获取用户微信信息
  getUserInfo({ code, openId, num }) {
    const accountId = getAccountId()
    let url = 'getUserInfo' + `?accountId=${accountId}&code=${code || ''}&openId=${openId || ''}&num=${num || ''}`
    return request({
      url: wechat2(url),
      method: 'post'
    })
  }
}
